import { Component, Input, OnInit } from '@angular/core';
import { Application } from '../../../shared/models/application.model';

@Component({
  selector: 'app-print-application',
  templateUrl: './print-application.component.html',
  styleUrls: ['./print-application.component.css'],
})
export class PrintApplicationComponent implements OnInit {
  @Input() application: Application;
  @Input() files: string[];

  constructor() {}

  ngOnInit(): void {}
}
